import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard/Dashboard';
import Login from './pages/Login/Login';
import Verify2FA from './pages/Verify2FA/Verify2FA';
import Patients from './pages/Patients/Patients';
import PatientDetail from './pages/PatientDetail/PatientDetail';
import Physicians from './pages/Physicians/Physicians';
import TabularData from './pages/TabularData/TabularData';
import Medications from './pages/Medications/Medications';
import Surveys from './pages/Surveys/Surveys';
import Settings from './pages/Settings/Settings';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/verify-2fa" element={<Verify2FA />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patients"
            element={
              <ProtectedRoute>
                <Dashboard><Patients /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/patients/:id"
            element={
              <ProtectedRoute>
                <Dashboard><PatientDetail /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/physicians"
            element={
              <ProtectedRoute>
                <Dashboard><Physicians /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tabular-data"
            element={
              <ProtectedRoute>
                <Dashboard><TabularData /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/medications"
            element={
              <ProtectedRoute>
                <Dashboard><Medications /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/surveys"
            element={
              <ProtectedRoute>
                <Dashboard><Surveys /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Dashboard><Settings /></Dashboard>
              </ProtectedRoute>
            }
          />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
